import type { TableReferenceResult } from '../../api/word/word-service'
import type { CurrentDocumentContextEntry } from '../../types'
import { omitTableCellTargets } from '../chat-context/omit-table-cell-targets'

export function collectTargetIds(entries: CurrentDocumentContextEntry[]): string[] {
  return entries
    .map((entry) => ('id' in entry ? entry.id : undefined))
    .filter((id): id is string => typeof id === 'string')
}

export type MergeTableHtmlReferencesResult = {
  /** Entries with table-cell targets omitted and `table_html` references appended. */
  contextEntries: CurrentDocumentContextEntry[]
  /** Same as pre-merge targets after omitTableCellTargets (no `table_html` entries). */
  filteredTargetEntries: CurrentDocumentContextEntry[]
  targetIdsInTables: ReadonlySet<string>
}

export function mergeTableHtmlReferencesIntoEntries(
  entries: CurrentDocumentContextEntry[],
  tableReferenceResult: TableReferenceResult
): MergeTableHtmlReferencesResult {
  const { references, targetIdsInTables } = tableReferenceResult
  const filteredTargetEntries = omitTableCellTargets(entries, targetIdsInTables)
  return {
    filteredTargetEntries,
    contextEntries: [...filteredTargetEntries, ...references],
    targetIdsInTables,
  }
}
